module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	model: {
		forwardFilterChanges: false,
		resourceConnected: false,
	},

	events: {
		refresh: {
			type: 'click',
			selector: 'button[data-field-type="refresh"]',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				if(event.data.component.model.tripTable){
					event.data.component.model.tripTable.refreshData();
				}
			}
		}
	},

	methods: {
		onChange(isRelationChange, changeDone, fieldData){
			if(this.model.forwardFilterChanges && this.model.tripTable){
				var data = (this.model.dirtyFields || {}).data || {};
				var attributes = data.attributes || {};

				this.model.tripTable.onFilterChanged(
					attributes,
					isRelationChange ? !(fieldData || {}).isLastRelationElement : false,
					isRelationChange ? (fieldData || {}).isLastRelationElement : false
				);
			}
		},
		submit: function(){}
	},

	hooks: {
		_attach($element, options){
			if(!this.model.controller){
				this.closest('templates_artCrm_entity_controller', c => this.model.controller = c)
			}
			if(!this.model.tripTable && this.model.controller){
				this.model.controller.find('templates_artCrm_trip_table', c => this.model.tripTable = c)
			}

			this.model.forwardFilterChanges = true
			if(Object.keys(((this.model.dirtyFields || {}).data || {}).attributes || {}).length > 0){
				this.onChange()
			}
		}
	}
}